var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"huy","transform":"translate(-338 -4)"},[React.createElement("circle",{"className":"button-close","cx":"18","cy":"18","r":"18","transform":"translate(338 4)","fill":"#e2e2e2","key":0}),React.createElement("path",{"className":"close-2","d":"M21.5,8.91,20.09,7.5,14.5,13.09,8.91,7.5,7.5,8.91l5.59,5.59L7.5,20.09,8.91,21.5l5.59-5.59,5.59,5.59,1.41-1.41L15.91,14.5Z","transform":"translate(341.5 7.5)","key":1})]));
}

Close.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = Close;

Close.default = Close;
